import { css } from "styled-components";

/**
 * This module is for media queries
 * Usage: ${MediaQuery.tablet`flex-direction: column;`}
 */

// @media (min-width: 992px) {
const MediaQuery = {
  desktop: (...args) => css`
    @media (min-width: 769px) {
      ${css(...args)};
    }
  `,
  tablet: (...args) => css`
    @media (max-width: 768px) {
      ${css(...args)};
    }
  `,
  phone: (...args) => css`
    @media (max-width: 426px) {
      ${css(...args)};
    }
  `
};

export default MediaQuery;



// WEBPACK FOOTER //
// ./src/components/MediaQuery/index.js